<template>
  <span>
    <img draggable="false" class="clickable" id="quit_btn_top" @click="goToStart()" src="./../../assets/images/Asset 58.png" alt="">
    <img draggable="false" class="clickable" id="ornament_reset_btn_top" @click="resetGameDialog()" src="./../../assets/images/Asset 45_.png" alt="">
    <img draggable="false" class="background_image" src="./../../assets/images/kerstmis/Asset 48.png" alt="">
    <img draggable="false" id="kerstmis_bottom_image" src="./../../assets/images/kerstmis/Asset 61.png" alt="">

    <span id="kerstmis_title_text_ornament">Sleep het ornament naar de juiste betekenis</span>
    <span id="ornament_text_1">Het teken aan de hemel dat de drie Wijzen uit het Oosten naar het kindje Jezus leidde</span>
    <span id="ornament_text_2">Zij brengen het licht in donkere dagen net zoals kindje Jezus voor christenen 'het Licht van de wereld' is</span>
    <span id="ornament_text_3">Een gebaar dat iemand blij met je is en je speciaal vindt. Hiermee gave de drie Wijzen uit het Oosten aan blij te zijn met kindje Jezus</span>
    <span id="ornament_text_4">Vorm die symbool staat voor het leven dat altijd doorgaat</span>
    <span id="ornament_text_5">Boodschapper tussen God en de mens brengen de blijde boodschap aan Maria en de herders</span>

    <div class="ornament_box" id="ornament_box_1" v-on:drop="drop($event)" v-on:dragover="allowDrop($event, 'ornament_box_1')"></div>
    <div class="ornament_box" id="ornament_box_2" v-on:drop="drop($event)" v-on:dragover="allowDrop($event, 'ornament_box_2')"></div>
    <div class="ornament_box" id="ornament_box_3" v-on:drop="drop($event)" v-on:dragover="allowDrop($event, 'ornament_box_3')"></div>
    <div class="ornament_box" id="ornament_box_4" v-on:drop="drop($event)" v-on:dragover="allowDrop($event, 'ornament_box_4')"></div>
    <div class="ornament_box" id="ornament_box_5" v-on:drop="drop($event)" v-on:dragover="allowDrop($event, 'ornament_box_5')"></div>

    <span v-if="render == 1">
      <img class="clickable" draggable="true" v-on:dragstart="drag($event)" id="ornament_1" src="./../../assets/images/kerstmis/Asset 78.png">
      <img class="clickable" draggable="true" v-on:dragstart="drag($event)" id="ornament_2" src="./../../assets/images/kerstmis/Asset 68.png">
      <img class="clickable" draggable="true" v-on:dragstart="drag($event)" id="ornament_3" src="./../../assets/images/kerstmis/Asset 76.png">
      <img class="clickable" draggable="true" v-on:dragstart="drag($event)" id="ornament_4" src="./../../assets/images/kerstmis/Asset 77.png">
      <img class="clickable" draggable="true" v-on:dragstart="drag($event)" id="ornament_5" src="./../../assets/images/kerstmis/Asset 69.png">
    </span>
  </span>
</template>

<script>
import swal from 'sweetalert2'

export default {
  name: "KerstmisOrnament",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {
      items_dropped: [],
      dropped_text: '',
      dropped_box: '',

      render: 1
    };
  },

  methods: {
    resetGameDialog() {
      var that = this
      new swal({
          allowEscapeKey: false,
          allowOutsideClick: false,
          title: "",
          html: `<p class='swal_html'>Wil je het opnieuw?</p>`,
          type: "success",
          showCancelButton: true,
          cancelButtonColor: '#d33',
          cancelButtonText: 'Nee, doorgaan',
          confirmButtonColor: "#9BCB3C",
          confirmButtonText: "Ja",
        }).then(function (confirm) {
          if ( confirm.isConfirmed ) {
            that.resetGame();
          } else {
            that.$router.push('/kerstmis/menu/1');
          }
        });
    },

    goToStart() {
      this.$router.push('/kerstmis/start');
    },

    goToKerstmisMenu() {
      this.$router.push('/kerstmis/menu/1');
    },

    allowDrop(event, box_type) {
      this.dropped_box = box_type;
      event.preventDefault();
    },

    drag(event) {
      event.dataTransfer.setData("text", event.target.id);
    },

    drop(event) {
      event.preventDefault();
      var data = event.dataTransfer.getData("text");
    
      this.dropped_text = data;

      if (
        this.dropped_box == 'ornament_box_2' && this.dropped_text == 'ornament_1' ||
        this.dropped_box == 'ornament_box_1' && this.dropped_text == 'ornament_2' ||
        this.dropped_box == 'ornament_box_3' && this.dropped_text == 'ornament_3' ||
        this.dropped_box == 'ornament_box_5' && this.dropped_text == 'ornament_4' ||
        this.dropped_box == 'ornament_box_4' && this.dropped_text == 'ornament_5'
      ) {
        event.target.appendChild(document.getElementById(data));
        
        this.items_dropped.push(data);

        document.getElementById(data).style.width = '32%'
        document.getElementById(data).style.marginTop = '0%'
        document.getElementById(data).style.left = '35%'
      }
      
    },

    resetGame() {
      this.items_dropped = []
      this.render = 0

      $('#ornament_1').remove()
      $('#ornament_2').remove()
      $('#ornament_3').remove()
      $('#ornament_4').remove()
      $('#ornament_5').remove()

      let that = this
      setTimeout(function() {
        that.render = 1
      }, 50)
    },
  },

  computed: {},

  watch: {
    items_dropped(count) {
      if ( count.length == 5 ) {
        this.resetGameDialog()
      }
    }
  }
};
</script>

<style>
  #ornament_reset_btn_top {
    position: absolute;
    margin-top: 1.5%;
    left: 2%;
    width: 15%;
    z-index: 1;
  }
  .ornament_box {
    position: absolute;
    height: 6%;
    border: 2px solid #000;
    left: 27%;
    width: 6%;
  }
  #ornament_box_1 {
    margin-top: 11.8%;
  }

  #ornament_box_2 {
    margin-top: 16.9%;
  }

  #ornament_box_3 {
    margin-top: 22.7%;
  }

  #ornament_box_4 {
    margin-top: 28%;
  }

  #ornament_box_5 {
    margin-top: 33.8%;
  }

  #kerst_play_btn {
    position: absolute;
    margin-top: 32%;
    left: 40%;
    width: 20%;
  }

  #ornament_1 {
    position: absolute;
    margin-top: 9%;
    left: 10%;
    width: 4%;
  }
  #ornament_2 {
    position: absolute;
    margin-top: 16%;
    left: 10%;
    width: 4%;
  }
  #ornament_3 {
    position: absolute;
    margin-top: 22%;
    left: 10%;
    width: 4%;
  }
  #ornament_4 {
    position: absolute;
    margin-top: 30%;
    left: 10%;
    width: 4%;
  }
  #ornament_5 {
    position: absolute;
    margin-top: 36%;
    left: 10%;
    width: 4%;
  }
  
  #kerstmis_title_text_ornament {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 3.7%;
    width: 65%;
    left: 17.5%;
    color: #1b7537;
    font-size: 2.7vw;
    text-align: center;
    z-index: 1;
  }
  #ornament_text_1 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 12%;
    width: 60%;
    left: 37%;
    color: #1b7537;
    font-size: 1.7vw;
    z-index: 1;
  }
  #ornament_text_2 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 17%;
    width: 60%;
    left: 37%;
    color: #1b7537;
    font-size: 1.7vw;
    z-index: 1;
  }
  #ornament_text_3 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 23%;
    width: 60%;
    left: 37%;
    color: #1b7537;
    font-size: 1.7vw;
    z-index: 1;
  }
  #ornament_text_4 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 29%;
    width: 60%;
    left: 37%;
    color: #1b7537;
    font-size: 1.7vw;
    z-index: 1;
  }
  #ornament_text_5 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 34%;
    width: 60%;
    left: 37%;
    color: #1b7537;
    font-size: 1.7vw;
    z-index: 1;
  }
</style>


